import { render, staticRenderFns } from "./price-rule-show.vue?vue&type=template&id=beac5074&scoped=true&"
import script from "./price-rule-show.vue?vue&type=script&lang=js&"
export * from "./price-rule-show.vue?vue&type=script&lang=js&"
import style0 from "./price-rule-show.vue?vue&type=style&index=0&id=beac5074&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beac5074",
  null
  
)

export default component.exports